import _defineProperty from '@babel/runtime/helpers/defineProperty';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getInputBoxProps = function getInputBoxProps(props, isTextarea, isTextareaAutoGrow, hasRows, disabled, handleOnFocus, handleOnBlur, hasTrailingSection) {
  var id = props.id,
    value = props.value,
    minLength = props.minLength,
    maxLength = props.maxLength,
    autoComplete = props.autoComplete,
    autoFocus = props.autoFocus,
    leadingAsset = props.leadingAsset,
    onChange = props.onChange,
    onClick = props.onClick,
    variant = props.variant;
  var inputProps = {
    id: id,
    value: value,
    disabled: disabled,
    minLength: minLength,
    maxLength: maxLength,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    onFocus: handleOnFocus,
    onBlur: handleOnBlur,
    onClick: onClick,
    onChange: onChange,
    width: '100%',
    borderWidth: '0',
    textColor: disabled ? 'base.disabled' : 'deprecated.secondary.interactive'
  };
  return variant === 'input' ? _objectSpread(_objectSpread({}, inputProps), {}, {
    px: '16',
    pt: '0',
    pb: isTextarea && hasRows ? '8' : '16',
    mt: isTextarea && !isTextareaAutoGrow ? '12' : '16',
    ps: leadingAsset ? '8' : '16',
    pe: hasTrailingSection ? '8' : '16'
  }) : _objectSpread(_objectSpread({}, inputProps), {}, {
    py: '12'
  });
};
var DEFAULT_MIN_ROWS = 3;
var DEFAULT_MAX_ROWS = 5;
var mapAutoGrowProps = function mapAutoGrowProps(minRowsProp, maxRowsProp) {
  var minRows = minRowsProp !== null && minRowsProp !== void 0 ? minRowsProp : Math.min(DEFAULT_MIN_ROWS, maxRowsProp !== null && maxRowsProp !== void 0 ? maxRowsProp : Infinity);
  var maxRows = maxRowsProp !== null && maxRowsProp !== void 0 ? maxRowsProp : Math.max(DEFAULT_MAX_ROWS, minRowsProp !== null && minRowsProp !== void 0 ? minRowsProp : 0);
  var isAutogrow = minRows < maxRows;
  return {
    HTMLTextAreaRows: undefined,
    isAutogrow: isAutogrow,
    minRows: minRows,
    maxRows: maxRows
  };
};
var mapStaticHeightProps = function mapStaticHeightProps(rowsProp) {
  return {
    isAutogrow: false,
    HTMLTextAreaRows: rowsProp,
    minRows: undefined,
    maxRows: undefined
  };
};
var resolveTextAreaRowsProps = function resolveTextAreaRowsProps(rowsProp, minRowsProp, maxRowsProp) {
  if (maxRowsProp !== undefined || minRowsProp !== undefined) {
    return mapAutoGrowProps(minRowsProp, maxRowsProp);
  }
  return mapStaticHeightProps(rowsProp);
};
var labelColorToken = {
  default: 'base.subtle',
  success: 'feedback.positive',
  error: 'feedback.negative',
  disabled: 'base.disabled'
};
function isIcon(asset) {
  return !!(asset && asset.id);
}

export { DEFAULT_MAX_ROWS, DEFAULT_MIN_ROWS, getInputBoxProps, isIcon, labelColorToken, resolveTextAreaRowsProps };
//# sourceMappingURL=InputHelper.js.map
